import { Page, QueryBase } from "../../../shared/models/models";

export interface CustomerSearchAndBuyState {
  query: ProductsQuery;
  products?: Page<Product>;
  product?: Product;
  loading: boolean;
  success?: string;
  error: any;
}

export interface ProductsQuery extends QueryBase<ProductsQueryParameter> {
}

export enum ProductsQueryParameter {
  name = 1,
  number = 2
}

export interface Product {
  id: string;
  createdDate: Date;
  modifiedDate: Date;
  number: string;
  name: string;
  description?: string;
  category: Category;
  manufacturer: Manufacturer;
}

export interface Category {
  id: string;
  name: string;
}

export interface Manufacturer {
  id: string;
  name: string;
}
